module.exports = __webpack_public_path__ + "img/ycli.b6814184.jpeg";